import React, { useState } from 'react'

import csrfHeaders, { csrfToken } from 'src/utils/csrfHeaders'

const errorResult = {
  status: 'danger',
  message: 'Something went wrong. Please try again.',
}

const Resend = props => {
  const [ result, setResult ] = useState(null)

  const handleSubmit = e => {
    e.preventDefault()

    fetch(props.resend.action, {
      method: 'POST',
      headers: csrfHeaders(),
      body: JSON.stringify({ email: props.resend.email })
    }).then(response => {
      if (response.ok)
        response.json().then(json => setResult(json))
      else
        setResult(errorResult)
    }).catch(error => {
      console.error(error)
      setResult(errorResult)
    })
  }

  return result
  ? <p className="mb-0 fw-bold">{result.message}</p>
  : <form method="post" action={props.resend.action} onSubmit={handleSubmit}>
      <div>
        <input type="hidden" name="authenticity_token" value={csrfToken()} />
        <input type="hidden" name="email" value={props.resend.email} />
        <button className="btn btn-link alert-link" style={{ padding: 0 }}>
          Resend {props.resend.type} instructions.
        </button>
      </div>
    </form>
}

export default Resend
